export const CLOSE_FILTERS_BUTTON = 'close-filters-button';
export const SELECTED_FILTER_TITLE = 'selected-filter-title';
export const FILTER_MODAL = 'filter-modal';
export const FILTER_OFFERS_KEY = 'qualifiers';
export const FILTERS_SEARCH_BAR = {
	DEPARTURE_PORT: 'departurePort',
	SHIP: 'ship',
};
